export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(amount);
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-IN');
};

export const formatDateTime = (date) => {
  return new Date(date).toLocaleString('en-IN');
};

export const calculateGST = (amount, gstRate = 18) => {
  return (amount * gstRate) / 100;
};

export const calculateTotal = (amount, gstRate = 18) => {
  return amount + calculateGST(amount, gstRate);
};

export const getRoleLabel = (role) => {
  const labels = {
    superadmin: 'Super Admin',
    vendor: 'Vendor Admin',
    captain: 'Captain',
    waiter: 'Waiter',
    billing: 'Billing Staff',
  };
  return labels[role] || role;
};

export const getInitials = (name) => {
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase();
};
